import React, { useContext } from 'react';

import { ApiContext } from '_lib/api/apiContext';

import { CallOutcomeEnum, activeCallOutcomes } from '_lib/api/apiTypes.shim';

import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

export interface CallOutcomeSelectProps extends FieldIssueProps {
  callOutcome?: string;
  onSetCallOutcome: (outcome: CallOutcomeEnum) => void;
}

export const CallOutcomeSelect = (props: CallOutcomeSelectProps): React.ReactElement => {
  const { callOutcome, issuePath, issues, onSetCallOutcome } = props;

  const api = useContext(ApiContext);
  const { data: appConfigData } = api.appConfig.useCachedAppConfigQuery();

  const selectableOutcomes = appConfigData?.callOutcomeConfig.activeOutcomes || activeCallOutcomes();

  const isSelectableOutcome = (outcome: string | undefined): outcome is CallOutcomeEnum =>
    !!outcome && selectableOutcomes.some((o) => o === outcome);

  return (
    <TextField
      fullWidth
      label='Call Outcome'
      required
      value={callOutcome || ''}
      select
      error={{
        issues,
        issuePath
      }}
      onChange={(e) => {
        if (isSelectableOutcome(e.target.value)) onSetCallOutcome(e.target.value);
      }}>
      {selectableOutcomes.map((outcome) => (
        <MenuItem key={outcome} value={outcome}>
          {outcome}
        </MenuItem>
      ))}
    </TextField>
  );
};
